<template>
  <div>
    <div>
      <div class="flex items-center justify-center px-5 py-5">
        <div class="w-full mx-auto h-auto rounded-xl shadow-sm p-5 text-gray-800 relative overflow-hidden">
          <div class="relative filter-tel teleconsultant">
            <div class="grid grid-cols-3 gap-4">
              <v-select v-if="currentUser.type && currentUser.type != 'TeleConsultant'"
                @search="getUsersDebance($event,'TeleConsultant')"
                label="fullName"
                :options="TabTeleConsultant"
                class="input-style"
                v-model="formData.teleConsultant"
                placeholder="Select TeleConsultant"
                @input="setSelected"
              >
              </v-select>
              <select
                id="type"
                name="date"
                autocomplete="type"
                v-model="duree"
                class="input-style"
              >
                <option>Today</option>
                <option>Yesterday</option>
                <option>This Month</option>
                <option>Last Month</option>
                <option>This Year</option>
                <option>Last Year</option>
              </select>
              <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="w-full-imp input-style" v-model="formData.startDate" range></date-picker>
              <!-- <input
                placeholder="Start Date"
                onfocus="(this.type='date')"
                v-model="formData.startDate"
                class="input-style"
              />
              <input
                class="input-style"
                placeholder="End Date"
                onfocus="(this.type='date')"
                v-model="formData.endDate"
              /> -->

            </div>
            <div class="grid grid-cols-3 gap-4 mt-4">
                    <v-select
                      @search="getUsersDebance($event,'Seller')"
                      @input="CheckSellerProducts($event,'seller')"
                      label="fullName"
                      placeholder='Seller'
                      :options="sellers"
                      v-model="sellerdata"
                      class="input-style"
                  
                  ></v-select>
                        <v-select
                        @search="getProducts($event,'shipsen')"
                        @input="CheckSellerProducts($event,'product')"
                        label="name"
                        placeholder="Product name ..."
                        :options="products"
                        :disabled="!sellerdata"
                        v-model="productdata"
                        class="input-style"
                      ></v-select>
                 <div class="flex">
                 <button style="background-color: #3182cf;" type="button" @click="getTotalStatusPerTeleconsultantBetweenTwoDate('Search')" class="border w-full font-semiborder-indigo-500 bg-indigo-500 text-white rounded-md transition duration-500 ease select-none hover:bg-indigo-600 focus:outline-none focus:shadow-outline loidingconfirm relative" :class="loading?'noselect':''">
                  <loading :active.sync="loading" :is-full-page="fullPage"></loading> Search <i style="vertical-align: middle;font-size: 23px;" class="material-icons">search</i>
                 </button>
               </div>       
              
            </div>
          </div>

        
          <div class="absolute top-0 left-0 w-full h-2 flex">
            <div class="h-1 bg-blue-500 flex-1"></div>
            <div class="h-1 bg-yellow-500 flex-1"></div>
            <div class="h-1 bg-blue-500 flex-1"></div>
            <div class="h-1 bg-yellow-500 flex-1"></div>
            <div class="h-1 bg-blue-500 flex-1"></div>
            <div class="h-1 bg-yellow-500 flex-1"></div>
          </div>
          <div class="mt-8">
            <div class="items-center">
                <div class="grid grid-flow-col gap-6">
                  <div class="card card-block card-stretch card-height relative text-primary">
                    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                     <div class="card-body bg-primary-light rounded">
                        <div class="d-flex align-items-center justify-content-between">
                           <div class="rounded iq-card-icon bg-primary"><img class="img-call" src="https://img.icons8.com/ios-filled/64/FFFFFF/headset.png"/>
                           </div>
                           <div class="text-right">
                              <h2 class="mb-0"><span class="counter" style="visibility: visible;">{{getPercentege(countOrderConf,countOrderConf+countOrderCan)}}%</span></h2>
                              <h5 class="">Confirmation Rate</h5>
                           </div>
                        </div>
                        <div class="separator separator-dashed my-2"></div>
                        
                        <div class="d-flex flex-stack">
                        
												<!--begin::Section-->
												<div class="text-info-line fw-semibold fs-6 me-2 d-flex align-items-center">
                          <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-info-line"></span>
                          <span class="text-gray-900 fw-bolder fs-6 mr-1">{{countOrderConf}} </span> Confirmed
                        </div>
												<!--end::Section-->
												<!--begin::Statistics-->
												<div class="d-flex align-items-senter">
													<!--begin::Number-->
                          <div class="text-cancelled-line fw-semibold fs-6 me-2 d-flex align-items-center">
                            <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-cancelled-line"></span>
                            <span class="text-gray-900 fw-bolder fs-6 mr-1">{{countOrderCan}} </span> Cancelled
                        </div>
												</div>
												<!--end::Statistics-->
											</div>
                     </div>
                     
                  </div>
                  <div class="card card-block card-stretch card-height relative text-info">
                    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                     <div class="card-body bg-info-light rounded">
                        <div class="d-flex align-items-center justify-content-between">
                           <div class="rounded iq-card-icon bg-info"><img class="img-call" src="https://img.icons8.com/wired/64/FFFFFF/checked-truck.png"/>
                           </div>
                           <div class="text-right">
                              <h2 class="mb-0"><span class="counter" style="visibility: visible;">{{getPercentege(countOrderPaid,countOrderConf)}}%</span></h2>
                              <h5 class="">Paid Rate</h5>
                           </div>
                        </div>
                        <div class="separator separator-dashed separator-paid my-2"></div>
                        
                        <div class="d-flex flex-stack">
                        
												<!--begin::Section-->
												<div class="text-gray-700 fw-semibold fs-6 me-2 d-flex align-items-center">
                          <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-trait-line"></span>
                          <span class="text-gray-900 fw-bolder fs-6 mr-1">{{countOrderConf}} </span> Traits
                        </div>
												<!--end::Section-->
												<!--begin::Statistics-->
												<div class="d-flex align-items-senter">
													<!--begin::Number-->
                          <div class="text-gray-700 fw-semibold fs-6 me-2 d-flex align-items-center">
                            <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-paid-line"></span>
                            <span class="text-gray-900 fw-bolder fs-6 mr-1">{{countOrderPaid}} </span> Paid
                        </div>
												</div>
												<!--end::Statistics-->
											</div>
                     </div>
                  </div>
                </div>
              </div>

            <div class="w-full">
                <div class="intro-y block sm:flex items-center h-10">
                   <h2 class="text-lg font-medium truncate mr-5 flex flex-no-wrap items-center"><svg width="24" class="fill-current mr-3" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M3.848 19h-.848c-.796 0-1.559-.316-2.121-.879-.563-.562-.879-1.325-.879-2.121v-3c0-7.175 5.377-13 12-13s12 5.825 12 13v3c0 .796-.316 1.559-.879 2.121-.562.563-1.325.879-2.121.879h-.848c-2.69 4.633-6.904 5-8.152 5-1.248 0-5.462-.367-8.152-5zm16.152-5.876c-.601.236-1.269-.18-1.269-.797 0-.304-.022-.61-.053-.915-1.761-.254-3.618-1.926-3.699-3.723-1.315 2.005-4.525 4.17-7.044 4.17 1.086-.699 1.839-2.773 1.903-3.508-.581 1.092-2.898 3.136-4.551 3.487l-.018.489c0 .619-.669 1.032-1.269.797v3.771c.287.256.632.464 1.041.594.225.072.412.224.521.424 2.206 4.046 5.426 4.087 6.438 4.087.929 0 3.719-.035 5.877-3.169-1.071.433-2.265.604-3.759.653-.37.6-1.18 1.016-2.118 1.016-1.288 0-2.333-.784-2.333-1.75s1.045-1.75 2.333-1.75c.933 0 1.738.411 2.112 1.005 1.9-.026 4.336-.334 5.888-2.645v-2.236zm-11-.624c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm6 0c.686 0 1.243.672 1.243 1.5s-.557 1.5-1.243 1.5-1.243-.672-1.243-1.5.557-1.5 1.243-1.5zm5.478-1.5h1.357c-.856-5.118-4.937-9-9.835-9-4.898 0-8.979 3.882-9.835 9h1.357c.52-4.023 3.411-7.722 8.478-7.722s7.958 3.699 8.478 7.722z"/></svg> Analytics Callcenter  </h2>
                   <div class="flex items-center sm:ml-auto mt-3 sm:mt-0">
                       <span class="loidingconfirm relative mr-3 cursor-pointer" :class="loading?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading> <svg @click="refresh" class=""  xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><path d="M20.944 12.979c-.489 4.509-4.306 8.021-8.944 8.021-2.698 0-5.112-1.194-6.763-3.075l1.245-1.633c1.283 1.645 3.276 2.708 5.518 2.708 3.526 0 6.444-2.624 6.923-6.021h-2.923l4-5.25 4 5.25h-3.056zm-15.864-1.979c.487-3.387 3.4-6 6.92-6 2.237 0 4.228 1.059 5.51 2.698l1.244-1.632c-1.65-1.876-4.061-3.066-6.754-3.066-4.632 0-8.443 3.501-8.941 8h-3.059l4 5.25 4-5.25h-2.92z"/></svg></span>
                       <button :class="{'cursor-not-allowed pointer-events-none':(TeleConsultantTab.length==0)}"  @click="downloadAnalytics"  class="btnn box flex items-center text-gray-700 dark:text-gray-300"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> Export to Excel </button>
                    </div>
                </div>
                <div class="boxed-tabs flex nav nav-tabs justify-center border-2 border-gray-700 border-dashed text-gray-600 dark:border-gray-700 dark:bg-dark-3 dark:text-gray-500 rounded-md p-1 mt-5 mx-auto" role="tablist">
                      <a v-for="(item, i) in dataAnalaytice" :key="i" :id="'active-'+item.type+'-tab'" @click="NavClick(item.type)"  data-toggle="tab" :data-target="'#active-'+item.type" href="javascript:;" :class="item.active?'active':''" class="btn-an flex-1 border-0 shadow-none py-2 px-2" role="tab" :aria-controls="'active-'+item.type" aria-selected="true">{{item.type}}</a>
                </div>
                
                <div class="intro-y overflow-auto lg:overflow-visible mt-8 sm:mt-0 tele" style="overflow-x: auto;">
                  <table  class="table table-report sm:mt-2 w-full">
                    <thead>
                    <tr>
                        <th class="whitespace-nowrap text-left">USER</th>
                        <th v-if="type!='System'" scope="col" class="uppercase text-center">Confirmation rate</th>
                        <th v-if="type!='System'" scope="col" class="uppercase text-center">Paid rate</th>
                        <th class="whitespace-nowrap text-center">NB ORDER TRAITS</th>
                        
                        <th v-if="type!='System'" class="text-center whitespace-nowrap">CONFIRMEDS</th>
                        <th v-if="type!='System'" class="text-center whitespace-nowrap">PAID (<img class="delevry-moto" src="https://img.icons8.com/material-rounded/24/000000/paid-bill.png"/>)</th>
                        <th class="text-center whitespace-nowrap">CANCELLEDS</th>
                        <th class="text-center whitespace-nowrap">{{type==='System'?'UNREACHED':'PENDING UNREACHED'}} </th>
                       
                        <th v-if="type!='System'"  class="whitespace-nowrap text-center">NB CALLS (<img class="delevry-moto" src="https://img.icons8.com/ios-glyphs/90/000000/outgoing-call.png"/>)</th>
                        <th class="text-center whitespace-nowrap actions">ACTIONS</th>
                    </tr>
                    </thead>
                      <tbody class="relative">
                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                        <tr class="intro-x" v-for="(item, index) in TeleConsultantTab" :key="index">
                             <td :style="`border-left: 4px ${getBgColor().code} solid;`"  :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''">
                                 <div class="flex">
                                    <div class="w-10 h-10 image-fit zoom-in">
                                       <div class="mr-3"><a :class="'bg-'+getBgColor().name" class="btn btn-circle btn-danger text-white uppercase">{{nameToInitials(DataParse(item.userData).fullName)}}</a></div>
                                    </div>
                                    <div class="flex-wrap image-fit zoom-in">
                                      <span class="flex w-full font-medium whitespace-nowrap uppercase">
                                          <span v-if="DataParse(item.userData).fullName" >
                                                {{ DataParse(item.userData).fullName }}
                                          </span>
                                          <div  v-else  class="loader12"></div>
                                      </span>
                                      <div v-if="DataParse(item.userData).status" class="w-full font-medium whitespace-nowrap">
                                          <div class="online-indicator"><span class="blink" :class="DataParse(item.userData).status=='Online'?'online':'offline'"></span></div>
                                          <h2 class="online-text">{{DataParse(item.userData).status}}</h2>
                                      </div>
                                    </div>
                                 </div>
                                 
                             </td>
                              <td v-if="type!='System'"  class="text-center text-center  border-l-2 border-gray-700 border-dashed"><vue-ellipse-progress reverse :loading="false"  :noData="false" dot="5" font-color="black" fontSize="1rem"  animation="bounce 700 1000" :empty-thickness="10" :thickness="7" :size="60" :empty-color="getcolor('Confirmed').gardien"  :color="getcolor('Confirmed').color"  :progress="getPercentege(item.confirmed,item.countAll)"> <span style="font-size: 12px;" slot="legend-value"><span> %</span></span></vue-ellipse-progress></td>
                              <td v-if="type!='System'"  class="text-center text-center  border-gray-700 border-dashed"><vue-ellipse-progress reverse :loading="false"  :noData="false" dot="5" font-color="black" fontSize="1rem"  animation="bounce 700 1000" :empty-thickness="10" :thickness="7" :size="60" :empty-color="getcolor('Paid').gardien"  :color="getcolor('Paid').color"  :progress="getPercentege(item.paid,item.confirmed)"> <span style="font-size: 12px;"  slot="legend-value"><span> %</span></span></vue-ellipse-progress> </td>
                               <td class="text-center text-center  border-r-2  border-l-2 border-gray-700 border-dashed" :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''"> {{ type==='System'?item.callAll:item.countAll }}</td>
                              
                               <td  v-for="(it, indx) in item.status.filter((obj) => (type != 'System' && (obj.name === 'Confirmed' || obj.name === 'Cancelled' || obj.name === 'Unreached' || obj.name === 'Paid')) ||  (type === 'System' && (obj.name === 'Unreached' || obj.name === 'Cancelled')))" :key="indx" class="text-center progre" :class="[(DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted' ? 'bg-redd' : ''), (it.name === 'Paid' ? 'border-l-2 border-r-2 border-gray-700 border-dashed' : '')]"> 
                
                                   <vue-ellipse-progress
                                      :progress="getPercentege(it.count,type==='System'?item.callAll:item.countAll,type==='System'?null:item.unrached)"
                                      :color="getcolor(it.name).color"
                                      :empty-color="getcolor(it.name).gardien"
                                      :size="80"
                                      :thickness="10"
                                      :empty-thickness="10"
                                      animation="bounce 700 1000"
                                      fontSize="1rem"
                                      font-color="black"
                                      dot="7"
                                      :noData="false"
                                      :loading="false"   
                                      reverse
                                    >
                                      <span slot="legend-value"><span> %</span></span>
                                      <div slot="legend-caption">
                                        <p style="font-size:10px" class="mb-0">Total: {{ it.count }} </p>
                                      </div>
                                    </vue-ellipse-progress>
                               </td>
                               <td v-if="type!='System'" class="text-center border-l-2 border-r-2 border-gray-700 border-dashed" :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''">  {{ item.callAll }}</td>
                              <td class="text-center actions" :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''">
                                <!-- <router-link :class="$colors.actionTable" :to="{path: `/callcenter/analytics/view/${item.user}`,}"><i class="material-icons mx-1">remove_red_eye</i></router-link> -->
                                <a href="#" class="text-blue-400  hover:text-blue-700  underline" @click="Detials(item)"><i class="material-icons mx-1">remove_red_eye</i></a>
                              </td>
                        </tr>
                        <tr v-if="TeleConsultantTab.length>0" class="intro-x">
                           <td class="text-center td-f">
                              <div class="flex items-center">
                              <div class="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                              <span class="truncate">Total:</span>
                              </div>
                           </td>
                           <td  v-if="type!='System'" class="text-center td-f"></td>
                           <td  v-if="type!='System'" class="text-center td-f"></td>
                           <td class="text-center td-f">
                             {{type==='System'?getTotalorders().call:countOrder }}
                           </td>
                           <td v-if="type!='System'" class="text-center td-f">
                            <vue-ellipse-progress
                                      :progress="getPercentege(type==='System'?countOrderUnr:countOrderConf,type==='System'?getTotalorders().call:getTotalorders().call)"
                                      color="#50c12c"
                                      empty-color="#beddb4"
                                      :size="95"
                                      :thickness="10"
                                      :empty-thickness="10"
                                      animation="bounce 700 1000"
                                      fontSize="1rem"
                                      font-color="black"
                                      dot="7"
                                      :noData="false"
                                      :loading="false"   
                                      reverse
                                    >
                                      <span slot="legend-value">
                                        <span> %</span>
                                      </span>
                                      <div slot="legend-caption">
                                        <p style="font-size:10px" class="mb-0">Total: {{ type==='System'?countOrderUnr:countOrderConf }} </p>
                                      </div>
                                    </vue-ellipse-progress>
                           </td>
                           <td v-if="type!='System'"  class="text-center td-f">
                            <vue-ellipse-progress
                                      :progress="getPercentege(countOrderPaid,type==='System'?getTotalorders().call:getTotalorders().total)"
                                      color="#96670b"
                                      empty-color="#e9b755"
                                      :size="95"
                                      :thickness="10"
                                      :empty-thickness="10"
                                      animation="bounce 700 1000"
                                      fontSize="1rem"
                                      font-color="black"
                                      dot="7"
                                      :noData="false"
                                      :loading="false"   
                                      reverse
                                    >
                                      <span slot="legend-value">
                                        <span> %</span>
                                      </span>
                                      <div slot="legend-caption">
                                        <p style="font-size:10px" class="mb-0">Total: {{ countOrderPaid }} </p>
                                      </div>
                                    </vue-ellipse-progress>
                           </td>
                           
                           <td  class="text-center td-f">
                               <vue-ellipse-progress
                                      :progress="getPercentege(countOrderCan,type==='System'?getTotalorders().call:getTotalorders().call)"
                                      color="#c51847"
                                      empty-color="#dfaebb"
                                      :size="95"
                                      :thickness="10"
                                      :empty-thickness="10"
                                      animation="bounce 700 1000"
                                      fontSize="1rem"
                                      font-color="black"
                                      dot="7"
                                      :noData="false"
                                      :loading="false"   
                                      reverse
                                    >
                                      <span slot="legend-value">
                                        <span> %</span>
                                      </span>
                                      <div slot="legend-caption">
                                        <p style="font-size:10px" class="mb-0">Total: {{ countOrderCan }} </p>
                                      </div>
                                    </vue-ellipse-progress>
                           </td>
                           <td  class="text-center td-f">
                               <vue-ellipse-progress
                                      :progress="getPercentege(countOrderUnr,type==='System'?getTotalorders().call:getTotalorders().call)"
                                      color="#7579ff"
                                      empty-color="#cccdf1"
                                      :size="95"
                                      :thickness="10"
                                      :empty-thickness="10"
                                      animation="bounce 700 1000"
                                      fontSize="1rem"
                                      font-color="black"
                                      dot="7"
                                      :noData="false"
                                      :loading="false"   
                                      reverse
                                    >
                                      <span slot="legend-value">
                                        <span> %</span>
                                      </span>
                                      <div slot="legend-caption">
                                        <p style="font-size:10px" class="mb-0">Total: {{ countOrderUnr }} </p>
                                      </div>
                                    </vue-ellipse-progress>
                           </td>
                           <td  v-if="type!='System'" class="text-center td-f">
                             {{getTotalorders().call}}
                           </td>
                           <td  class="text-center td-f actions"></td>
                        </tr>
                        <tr v-if="TeleConsultantTab.length==0" class="intro-x"><td class="text-center padding-empty" :colspan="type==='System'?5:10">No data found</td></tr>
                      </tbody>
                  </table>
                   <!--pagination -->
                   <div id="loadMore" v-if="TeleConsultantTab.length>0 && !pagination.end" class="p-1 loadMore">
                        <div class="line l"></div>
                        <button  @click="loadMore" class="custom-btn btn-16 loidingconfirm relative border-2 border-gray-700 border-dashed" :class="loading?'noselect':''"><loading :active.sync="loading" :is-full-page="fullPage"></loading> <svg aria-hidden="true" data-prefix="far" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down fa-w-14 Icon__StyledIcon-sc-1pfgdmr-0 DataList__StyledIcon-b38vt8-0 fixYpc" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg> Load more ...</button>
                        <div class="line r"></div>
                    </div>
                    <!--end pagination -->
                </div>   
                 <!-- <div class="p-1">
                  <div class="flex flex-col items-center my-12">
                    <div v-if="paginate.lastpage > 1" class="flex text-gray-700">
                      <button
                        v-if="paginate.currentpage > 1"
                        @click="prev"
                        :disabled="paginate.currentpage == 1"
                        class="h-8 w-8 focus:outline-none mr-6 flex justify-center text-blue-600 items-center rounded-full bg-gray-200 hover:bg-blue-500 hover:text-white cursor-pointer"
                      >
                        <i class="material-icons"> keyboard_arrow_left </i>
                      </button>
                      <div class="flex h-8 font-medium rounded-full bg-gray-200">
                        <div
                          v-if="paginate.currentpage != paginate.lastpage"
                          class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full bg-blue-500 text-white"
                        >
                          {{ paginate.currentpage }}
                        </div>
                        <div
                          v-else
                          class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                        >
                          <span v-if="paginate.currentpage != 1"> 1 </span>
                        </div>

                        <div
                          v-if="paginate.currentpage >= 1 && paginate.lastpage != 1"
                          class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                        >
                          ...
                        </div>

                        <button
                          :class="
                            paginate.currentpage == paginate.lastpage
                              ? 'bg-blue-500 text-white'
                              : ' '
                          "
                          class="w-8 md:flex justify-center items-center hover:bg-blue-500 hover:text-white focus:outline-none hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                        >
                          {{ paginate.lastpage }}
                        </button>
                      </div>
                      <button
                        v-if="paginate.currentpage < paginate.lastpage"
                        :disabled="paginate.currentpage == paginate.lastpage"
                        @click="next"
                        class="h-8 w-8 ml-6 focus:outline-none flex justify-center text-blue-600 items-center rounded-full bg-gray-200 hover:bg-blue-500 hover:text-white cursor-pointer"
                      >
                        <i class="material-icons"> keyboard_arrow_right </i>
                      </button>
                    </div>
                  </div>
                 </div>  -->
            </div>
          </div>
        </div>
      </div>
    </div>
     <dialog class="printingExcel" >
       <div id="pdf" style="top: 0px;left: 0px;right: 0px;bottom: 0px;background-color: white;font-size: 14px;font-family: sans-serif;overflow:scroll;">
          <div class="paper" style="width: 720px;margin: auto;">
            <table id="p-table" class="table table-report sm:mt-2 w-full">
                    <thead>
                    <tr>
                        <th class="whitespace-nowrap text-left">USER</th>
                        <th v-if="type!='System'" scope="col" class="uppercase text-center">Confirmation rate</th>
                        <th v-if="type!='System'" scope="col" class="uppercase text-center">Paid rate</th>
                        <th class="whitespace-nowrap text-center">NB ORDER TRAITS</th>
                        
                        <th v-if="type!='System'" class="text-center whitespace-nowrap">CONFIRMEDS</th>
                        <th v-if="type!='System'" class="text-center whitespace-nowrap">PAID </th>
                        <th class="text-center whitespace-nowrap">CANCELLEDS</th>
                        <th class="text-center whitespace-nowrap">{{type==='System'?'UNREACHED':'PENDING UNREACHED'}} </th>
                       
                        <th v-if="type!='System'"  class="whitespace-nowrap text-center">NB CALLS </th>
                        
                    </tr>
                    </thead>
                      <tbody class="relative">
                        <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                        <tr class="intro-x" v-for="(item, index) in TeleConsultantTab" :key="index">
                             <td >
                              <span v-if="DataParse(item.userData).fullName" >{{ DataParse(item.userData).fullName }}</span>
                             </td>
                              <td v-if="type!='System'"  class="text-center text-center  border-l-2 border-gray-700 border-dashed"> <span style="font-size: 12px;" slot="legend-value"><span>{{getPercentege(item.confirmed,item.countAll)}} %</span></span></td>
                              <td v-if="type!='System'"  class="text-center text-center  border-gray-700 border-dashed"> <span style="font-size: 12px;"  slot="legend-value"><span>{{getPercentege(item.paid,item.confirmed)}} %</span></span></td>
                               <td class="text-center text-center  border-r-2  border-l-2 border-gray-700 border-dashed" :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''"> {{ type==='System'?item.callAll:item.countAll }}</td>
                              
                               <td  v-for="(it, indx) in item.status.filter((obj) => (type != 'System' && (obj.name === 'Confirmed' || obj.name === 'Cancelled' || obj.name === 'Unreached' || obj.name === 'Paid')) ||  (type === 'System' && (obj.name === 'Unreached' || obj.name === 'Cancelled')))" :key="indx" class="text-center progre" :class="[(DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted' ? 'bg-redd' : ''), (it.name === 'Paid' ? 'border-l-2 border-r-2 border-gray-700 border-dashed' : '')]"> 
                
                                <span slot="legend-value"><span>{{ it.count }} ({{getPercentege(it.count,type==='System'?item.callAll:item.countAll,type==='System'?null:item.unrached)}}%)</span></span>
                               </td>
                               <td v-if="type!='System'" class="text-center border-l-2 border-r-2 border-gray-700 border-dashed" :class="DataParse(item.userData).fullName && DataParse(item.userData).fullName=='User deleted'?'bg-redd':''">  {{ item.callAll }}</td>
                             
                        </tr>
                        <tr v-if="TeleConsultantTab.length>0" class="intro-x">
                           <td class="text-center td-f">
                              <div class="flex items-center">
                              <div class="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                              <span class="truncate">Total:</span>
                              </div>
                           </td>
                           <td  class="text-center td-f"></td>
                           <td  class="text-center td-f"></td>
                           <td class="text-center td-f">
                             {{type==='System'?getTotalorders().call:countOrder }}
                           </td>
                           <td class="text-center td-f">
                            <span>{{ type==='System'?countOrderUnr:countOrderConf }} ({{getPercentege(type==='System'?countOrderUnr:countOrderConf,type==='System'?getTotalorders().call:getTotalorders().call)}}%)</span>
                           </td>
                           <td v-if="type!='System'"  class="text-center td-f">
                            <span>{{ countOrderPaid }} ({{getPercentege(countOrderPaid,type==='System'?getTotalorders().call:getTotalorders().total)}}%)</span>
                           </td>
                           
                           <td  class="text-center td-f">
                            <span> {{ countOrderCan }} ({{getPercentege(countOrderUnr,type==='System'?getTotalorders().call:getTotalorders().call)}}%)</span>
                           </td>
                           <td  class="text-center td-f">
                            <span>{{ countOrderUnr }} ({{getPercentege(countOrderUnr,type==='System'?getTotalorders().call:getTotalorders().call)}}%)</span>
                           </td>
                           <td  v-if="type!='System'" class="text-center td-f">
                             {{getTotalorders().call}}
                           </td>
                          
                        </tr>
                        <tr v-if="TeleConsultantTab.length==0" class="intro-x"><td class="text-center padding-empty" :colspan="type==='System'?5:10">No data found</td></tr>
                      </tbody>
                  </table>
                  
          </div>
      </div>
    </dialog>
     <!--Modal reporté shipping-->
     <vue-modal-2   name="ModalInfoTeleconsulatant" :headerOptions="{title:`TeleConsultant: ${infoTeleconsultant.user.name}`}" :noFooter="true" modalSize="xl" @on-close="close()">
          <div class="w-full bg-white rounded-lg p-4 pt-0 pb-0">
                <div class="items-center">
                  <div class="grid grid-flow-col gap-6">
                  <div class="card card-block card-stretch card-height relative text-primary">
                    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                     <div class="card-body bg-primary-light rounded">
                        <div class="d-flex align-items-center justify-content-between">
                           <div class="rounded iq-card-icon bg-primary"><img class="img-call" src="https://img.icons8.com/ios-filled/64/FFFFFF/headset.png"/>
                           </div>
                           <div class="text-right">
                              <h2 class="mb-0"><span class="counter" style="visibility: visible;">{{getPercentege(infoTeleconsultant.confirmed,infoTeleconsultant.confirmed+infoTeleconsultant.cancelled)}}%</span></h2>
                              <h5 class="">Confirmation Rate</h5>
                           </div>
                        </div>
                        <div class="separator separator-dashed my-2"></div>
                        
                        <div class="d-flex flex-stack">
                        
												<!--begin::Section-->
												<div class="text-info-line fw-semibold fs-6 me-2 d-flex align-items-center">
                          <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-info-line"></span>
                          <span class="text-gray-900 fw-bolder fs-6 mr-1">{{infoTeleconsultant.confirmed}} </span> Confirmed
                        </div>
												<!--end::Section-->
												<!--begin::Statistics-->
												<div class="d-flex align-items-senter">
													<!--begin::Number-->
                          <div class="text-cancelled-line fw-semibold fs-6 me-2 d-flex align-items-center">
                            <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-cancelled-line"></span>
                            <span class="text-gray-900 fw-bolder fs-6 mr-1">{{infoTeleconsultant.cancelled}} </span> Cancelled
                        </div>
												</div>
												<!--end::Statistics-->
											</div>
                     </div>
                     
                  </div>
                  <div class="card card-block card-stretch card-height relative text-info">
                    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
                     <div class="card-body bg-info-light rounded">
                        <div class="d-flex align-items-center justify-content-between">
                           <div class="rounded iq-card-icon bg-info"><img class="img-call" src="https://img.icons8.com/wired/64/FFFFFF/checked-truck.png"/>
                           </div>
                           <div class="text-right">
                              <h2 class="mb-0"><span class="counter" style="visibility: visible;">{{getPercentege(infoTeleconsultant.paid,infoTeleconsultant.confirmed)}}%</span></h2>
                              <h5 class="">Paid Rate</h5>
                           </div>
                        </div>
                        <div class="separator separator-dashed separator-paid my-2"></div>
                        
                        <div class="d-flex flex-stack">
                        
												<!--begin::Section-->
												<div class="text-gray-700 fw-semibold fs-6 me-2 d-flex align-items-center">
                          <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-trait-line"></span>
                          <span class="text-gray-900 fw-bolder fs-6 mr-1">{{infoTeleconsultant.confirmed}} </span> Traits
                        </div>
												<!--end::Section-->
												<!--begin::Statistics-->
												<div class="d-flex align-items-senter">
													<!--begin::Number-->
                          <div class="text-gray-700 fw-semibold fs-6 me-2 d-flex align-items-center">
                            <span class="bullet bullet-vertical d-flex align-items-center min-h-70px mh-100 me-4 bg-paid-line"></span>
                            <span class="text-gray-900 fw-bolder fs-6 mr-1">{{infoTeleconsultant.paid}} </span> Paid
                        </div>
												</div>
												<!--end::Statistics-->
											</div>
                     </div>
                  </div>
                </div>
                <div class="flex">
                    <button style="margin-left: auto;" :disabled="dataExcel.loading" @click="downloadExcel('history')" class="btnn box cursor-pointer flex items-center text-gray-700 dark:text-gray-300">
                      <loading :active.sync="dataExcel.loading" :is-full-page="fullPage"></loading>
                      <svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text hidden sm:block w-4 h-4 mr-2 hidden sm:block w-4 h-4 mr-2"><path  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline  points="14 2 14 8 20 8"></polyline><line  x1="16" y1="13" x2="8" y2="13"></line><line  x1="16" y1="17" x2="8" y2="17"></line><polyline  points="10 9 9 9 8 9"></polyline></svg>
                       <span v-if="dataExcel.loading" class="inline-block loading-excel"> Exporting ({{timer}}/ {{paginate.total}}) <span>.</span><span>.</span><span>.</span> </span><span v-else> Export to Excel </span>
                    </button>
                </div>

                </div>
                 <div-table
                  :config="configList"
                  :idWharhouse="idWharhouse"
                  :currentUser="currentUser"
                  :data="infoTeleconsultant.dataOrders"
                  :loading="infoTeleconsultant.loading"
                  :paginate="paginate"
                  @paginatation="paginatation"
                  @refresh="refresh"
                ></div-table>
          </div> 
    </vue-modal-2 > 
  </div>
</template>
<script>
import HeaderFilters from "@/components/Analytics/Cards/HeaderFilters.vue";
import chartCallcenter from "@/components/Analytics/Cards/chartCallcenter.vue";
import config from "./configStatus";
// Example custom build usage:
import Cookies from 'js-cookie'


export default {
  components: {
    HeaderFilters,
    chartCallcenter,
  },
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
  data() {
    return {
      configList: config.list,
      formData: {
        teleConsultant: "",
        startDate: "",
        endDate: "",
      },
      nav:{
         tel:true,
         nrp:false
      },
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      duree: "Today",
      TeleConsultantTab: [],
      teleconsultant: "",
      teleconsultantId: "",
      TabTeleConsultant: [],
      loading:false,
      fullPage: false,
      countOrder:0,
      countCallOrder:0,
      countOrderConf:0,
      countOrderCan:0,
      countOrderPaid:0,
      countOrderUnr:0,
      //currentUser:{},
     // idWharhouse:null,
      dataAnalaytice:[ {type: 'TeleConsultant',users:[],active:true},{type: 'NRP',users:[],active:false}],
      type:"TeleConsultant",
      infoTeleconsultant:{user:{name:"",id:null},dataOrders:[],loading:false,confirmed:0,cancelled:0,paid:0},
      sellers:[],
      products:[],
      productdata:null,
      sellerdata:null,
      sellerSelected:null,
      dataUsers:[],
      pagination:{page:1,end:false},
      dataExcel:{loading:false,data:[]},
      timer: 0,
      interval: null,
    };
  },
  computed: {
        warhouseSelected(){
            return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
        },
  }, 
  async mounted() {
    //await this.getUser();
    //await this.getwharhouseId();
    await this.getUsers();
    this.duree = "Today";
    this.pagination={page:1,end:false};
    await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Today"});
    this.emptyCount();
    await this.getTotal();
    await this.getSellers();
    //console.log('this.paginate',this.paginate)
    // Loop over all stored values

  },
  methods: {
    downloadExcel:async function (name) {
        var htmls = "";
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'; 
        var base64 = function(s) {
            return window.btoa(unescape(encodeURIComponent(s)))
        };

        var format = function(s, c) {
            return s.replace(/{(\w+)}/g, function(m, p) {
                return c[p];
            })
        };

        let table =document.getElementById("p-table");

         if(name == 'history'){

            this.dataExcel.data=[];table='';
            this.dataExcel.loading=true;
            let filters={};
            
            filters.user= this.infoTeleconsultant.user.id;
            filters.warehouse= this.idWharhouse._id;
            filters.DateType= this.duree;
            if(this.sellerdata) filters.seller=this.sellerdata._id||this.sellerdata;
            if(this.productdata) filters.product=this.productdata._id||this.productdata;
            
            if (this.formData.startDate && Array.isArray(this.formData.startDate) && this.formData.startDate.filter(function(el) { return el; }).length==2){
              filters.startDate=this.formData.startDate.map( el => this.$moment(el).format('yyyy-MM-DD'));
              filters.endDate=this.formData.endDate;
            } 

            // return false
          //  console.log('filter export to excell ----',filters)
            var itemsCounts=300;
            filters.limit=itemsCounts;
            filters.page = 1;
            // filters['orderObjet.feesShipp']=-1;
            var count = Math.ceil(this.paginate.total/itemsCounts);
            var close=false;
            
            console.log('total ----',this.paginate.total)
            console.log('count  ----',count)
            console.log('filters  ----',filters)
            for (var i = 0; i <count; i++) {
                if(close) return;
                const resAllshipp = await this.$server.search("statusHistories",filters);
                 console.log('resAllshipp export to excell ----',resAllshipp)
               // return false
                if(resAllshipp.content.results) {
                    this.timer+=resAllshipp.content.results.length;
                    filters.page++;
                    this.dataExcel.data.push(...resAllshipp.content.results);
                }else close=true  

                if(close)  {this.timer=0;this.dataExcel.loading=false;alert("An error occurred, please reload the page and try again !!", "error"); }
            }

            // const resAllshipp = await this.$server.search("shippings",filters);
            if(this.dataExcel.data.length>0) {
                this.timer=0;
                this.dataExcel.loading=false;
                console.log('dataExcel--------------',this.dataExcel.data)
                table=`<table id="p-table" class="table w-full text-left whitespace-no-wrap">
                <thead class="bg-gray-200">
                    <tr class="text-left">
                         <th class="border p-1 text-center ">ORDER ID</th>
                        <th class="border p-1 text-center ">DATE</th>
                        <th class="border p-1 text-center ">TIME SPENT</th>
                        <th class="border p-2 text-center">PREVIOUS STATUS</th>
                        <th class="border p-2 text-center">CHANGE TO</th>
                        <th class="border p-2 text-center">COMMENT</th>
                    </tr>
                </thead>
                <tbody>`;
                if(this.dataExcel.data.length == 0){
                    table+=`<tr><th class="border p-3 bg-gray-100" colspan="12">No data Found</th></tr>`;
                }    
                for (const item of this.dataExcel.data) {
                    table+= 
                    `<tr class="text-center">
                        <td class="border p-2  bg-green-100">${ this.$f.getIdbySplit(item.order.id) }</td>
                        <td class="border p-2  bg-green-100">${ this.$moment(item.date).format('DD-MM-YYYY')}</td>
                        <td class="border p-2"><span class="flex items-center">${ item.timeConsumed||'' }</span></td>
                        <td class="border p-2"><span class="flex items-center">${ item.previousStatus?item.previousStatus.name:'' }</span></td>
                        <td class="border p-2"><span class="flex items-center">${ item.status?item.status.name:'' }</span></td>
                        <td class="border p-2"><span class="flex items-center">${ item.comment||'' }</span></td>
                    </tr>`;
                }
                
                
                table+= `</tbody> </table>`;  
                let parser = new DOMParser();
                let doc = parser.parseFromString(table, 'text/html');
                table=doc.body;
            }else this.dataExcel.loading=false;

             
         }
      
        console.log('table html 22------',table)
        htmls =table.outerHTML
        var ctx = {
            worksheet : `analyticsCall_${this.infoTeleconsultant.user.name}`,
            table : htmls
        }

        var link = document.createElement("a"); 
        link.download = `analyticsCall_${this.infoTeleconsultant.user.name||this.$moment(Date.now()).format('DD-MM-YYYY')}.xls`;
        link.href = uri + base64(format(template, ctx));
        link.click();         
    },
    async loadMore(){
      this.pagination.page++;
      if(this.formData.startDate && Array.isArray(this.formData.startDate) && this.formData.startDate.filter(function(el) { return el; }).length==2){
         await this.getTotalStatusPerTeleconsultantBetweenTwoDate();
       }else await this.getTotalOrdersPerTeleConsultant({IntervaleDate: this.duree});
    },
    getcolor(name){
       if(name=='Cancelled') return {color:'#c51847',gardien:'#dfaebb'};
       else if(name=='Confirmed') return {color:'#50c12c',gardien:'#beddb4'};
       else if(name=='Paid') return {color:'#96670b',gardien:'#e9b755'};
       else return {color:'#7579ff',gardien:'#cccdf1'};
    },
    close(){
      this.$vm2.close('ModalInfoTeleconsulatant');
    },
    async Detials(data){
      this.infoTeleconsultant.user.name=this.DataParse(data.userData).fullName;
      console.log('data--------',data)
      
      this.infoTeleconsultant.user.id=data.user;
      this.infoTeleconsultant.confirmed=data.status.find(o => o.name === "Confirmed").count;
      this.infoTeleconsultant.cancelled=data.status.find(o => o.name === "Cancelled").count;
      this.infoTeleconsultant.paid=data.status.find(o => o.name === "Paid").count;
      this.$vm2.open('ModalInfoTeleconsulatant');
      await this.getStatusHistories({});
    },
  emtydataAnalaytice(){
     this.dataAnalaytice=[ {type: 'TeleConsultant',users:[],active:true},{type: 'NRP',users:[],active:false}];
  },
  getBgColor(){
       var colors = [{name:'gray-400',code:'#cbd5e0'}, {name:'red-500',code:'#f56565'}, {name:'yellow-500',code:'#ecc94b'}, {name:'green-600',code:'#38a169'}, {name:'blue-600',code:'#3182ce'},{name:"pink-600",code:'#d53f8c'}];

       return  colors[Math.floor(Math.random() * colors.length)];
  },
  async getSellers() {
      if(this.idWharhouse && this.currentUser && this.currentUser.role && this.currentUser.role.name && this.currentUser.role.name != "Seller" && this.currentUser.type != "Seller") {
          const res = await this.$server.search("users", {type: "Seller",warehouses:this.idWharhouse._id,limit:10,});
          console.log('ressellers',res)
          if (res.content.results) this.sellers = res.content.results;
          else this.sellers = [];
       }else this.sellers = [];
    },
  async NavClick(type){
    this.loading=true;
    this.type=type;
    this.dataAnalaytice.forEach(p => { if(p.type === type) p.active=true; else p.active=false});
    await this.gateDatausersByType();  
    setTimeout(() => (this.loading = false), 1000);
  },
  getProducts: _.debounce(async function(name) {
         console.log('event______________',name)
          const filter={seller: this.sellerSelected,warhouse:this.idWharhouse._id,search:name};
          console.log('filter______________',filter)
          if(this.sellerSelected) await this.$store.dispatch('wharhouse/searchProducts',filter).then((res) => {this.products = res;})
  }, 500), 
  async CheckSellerProducts(seller=null,model){
        console.log('seller-------',seller)
        console.log('model-------',model)
       if(model && model=='seller'){
          if(seller && seller._id){
              this.sellerSelected=seller._id;
              this.sellerdata=seller;
              this.products = [];
              const res = await this.$server.search("products", { 'details.warehouse':this.idWharhouse._id,seller: seller._id,limit:10 });
              console.log('res product--------',res.content)
              if (res.content.results) {
                this.products = res.content.results;
              } else this.products = [];
         }else {this.sellerSelected=null;this.products = [];this.sellerdata=null,this.productdata=null}
       }else{
        if(seller && seller._id) this.productdata=seller;
        else this.productdata=null;
       }
    },
  async gateDatausersByType(){
      this.TeleConsultantTab=[];
      console.log('gateDatausersByType---')
      if(this.dataAnalaytice){
          var foundItem = this.dataAnalaytice.find(obj=>obj.type===this.type);
          if(foundItem) this.TeleConsultantTab=foundItem.users;
          console.log('analytices tele',this.TeleConsultantTab)
          for (const tel of this.TeleConsultantTab) {
            //if(!Cookies.get(this.TeleConsultantTab[i].user.toString())){
              let userData={fullName:"System"};
              if(tel.user != "System"){
                if(!this.dataUsers.find(o => o.id.toString() === tel.user.toString())){
                    const getUser=await this.getUserById(tel.user);
                    this.dataUsers.push({id:getUser.res._id.toString(),fullName:getUser.res.fullName||getUser.res.email,status:getUser.activite})
                }
                userData=this.dataUsers.find(o => o.id.toString() === tel.user.toString());
               } 
              
              // tel.userData= JSON.stringify(userData);
               tel.userData= userData;
            //  var inFifteenMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);
             // Cookies.set(this.TeleConsultantTab[i].user.toString(), JSON.stringify(userData), { expires: inFifteenMinutes })
             // Cookies.remove(this.TeleConsultantTab[i].user.toString()); // fail!
          //  }else {this.TeleConsultantTab[i].userData=Cookies.get(this.TeleConsultantTab[i].user);}
          }

          this.emptyCount();
          await this.getTotal();
      }
      console.log('gateDatausersByType--- 22',this.TeleConsultantTab)
      // console.log('Cokies item --------',Cookies.get()) //get all cockies
  },
  DataParse(data){
    if (typeof data !== 'undefined') {
       return data;
    }
    return ''; 
  },
  async getwharhouseId(){
        await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
  async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
  nameToInitials(fullName) {
    //console.log('fullName------',fullName)
    if (typeof fullName !== 'undefined' && fullName) {
      const namesArray = fullName.trim().split(' ');
      if (namesArray.length === 1) return `${namesArray[0].charAt(0)}`;
      else return `${namesArray[0].charAt(0)}${namesArray[namesArray.length - 1].charAt(0)}`;
    }else return fullName;
  },
  getTotalorderUser(data){
     let count=0;
      data.forEach(arg => {
        if(arg.name=="Confirmed" || arg.name=="Cancelled")  count+=arg.count;
      });
     return count;
  },
  getTotalorders(){
     var total = 0;var call = 0;
     this.TeleConsultantTab.forEach(arg => {total += arg.countAll;call += arg.callAll});
     return {total:total,call:call};
  },
  getPercentege(countStatus,total,unrached){
    if(unrached) total=total+unrached;
    return total?Math.round((countStatus * 100) /  total):0;
  },
  emptyCount(){
     this.countOrder=this.countOrderConf=this.countOrderCan=this.countOrderPaid=this.countOrderUnr=0
  },
  async downloadAnalytics(){

    if(this.TeleConsultantTab.length>0 && !this.pagination.end){
        alert(`Please click sur le button Load more !`, "warning");
        location.hash = "#loadMore";
        return false;
    }
      var htmls = "";
      var uri = 'data:application/vnd.ms-excel;base64,';
     
      var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>.actions{display:none}</style></head><body><table>{table}</table></body></html>'; 
      var base64 = function(s) {
          return window.btoa(unescape(encodeURIComponent(s)))
      };

      var format = function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
              return c[p];
          })
      };
      const table =document.getElementById("p-table");
      htmls =table.outerHTML
      var ctx = {
          worksheet : 'Analytics_Callcenter',
          table : htmls
      }

      var link = document.createElement("a");
      link.download = "Analytics_Callcenter.xls";
      link.href = uri + base64(format(template, ctx));
      link.click();
    },
    setSelected(teleconsultant) {
      if (teleconsultant) {
        this.teleconsultantId = teleconsultant._id;
      } else {
        this.teleconsultantId = "";
      }
    },
    getTotal(){
         for(let i in this.TeleConsultantTab) {
            this.countOrder += this.getTotalorderUser(this.TeleConsultantTab[i].status);
              for(let j in this.TeleConsultantTab[i].status) {
                if(this.TeleConsultantTab[i].status[j].name=="Confirmed") this.countOrderConf += this.TeleConsultantTab[i].status[j].count;
                 if(this.TeleConsultantTab[i].status[j].name=="Cancelled") this.countOrderCan += this.TeleConsultantTab[i].status[j].count;
                  if(this.TeleConsultantTab[i].status[j].name=="Unreached") this.countOrderUnr += this.TeleConsultantTab[i].status[j].count;
                  if(this.TeleConsultantTab[i].status[j].name=="Paid") this.countOrderPaid += this.TeleConsultantTab[i].status[j].count;

                  
              }
        }
    },
    async getStatusHistories(filters) {
        filters.user= this.infoTeleconsultant.user.id;
        filters.warehouse= this.idWharhouse._id;
        filters.DateType= this.duree;
        if(this.sellerdata) filters.seller=this.sellerdata._id||this.sellerdata;
        if(this.productdata) filters.product=this.productdata._id||this.productdata;
        
        if (this.formData.startDate && Array.isArray(this.formData.startDate) && this.formData.startDate.filter(function(el) { return el; }).length==2){
          filters.startDate=this.formData.startDate.map( el => this.$moment(el).format('yyyy-MM-DD'));
          filters.endDate=this.formData.endDate;
        } 
        this.infoTeleconsultant.loading=true;
        const res = await this.$server.search("statusHistories", filters);
        this.infoTeleconsultant.loading=false;
        if (res.content.results) {
            this.infoTeleconsultant.dataOrders = res.content.results;
            this.paginate.total = res.content.total;
            this.paginate.lastpage = res.content.last_page;
            this.paginate.per_page = res.content.per_page;
            this.paginate.currentpage = res.content.current_page;
            for(let i in this.infoTeleconsultant.dataOrders){
              this.infoTeleconsultant.dataOrders[i].order_id=this.infoTeleconsultant.dataOrders[i].order.id;
            }
        } else{ this.infoTeleconsultant.dataOrders = [];this.pagination={page:1,end:false}; this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}};
       
        console.log('this content ststus__',this.infoTeleconsultant.dataOrders )
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      const filters = {
        page: page,
        limit: 10,
      };
      this.getStatusHistories(filters);
    },
    async getUsers() {
      const filters = {
        type: "TeleConsultant",
        warehouses:this.idWharhouse._id,
        limit:10
      };
      const res = await this.$server.search("users", filters);
      if (res.content.results) {
        this.TabTeleConsultant = res.content.results;
      } else this.TabTeleConsultant = [];
    },
   getUsersDebance: _.debounce(async function(name,type) {
        console.log('name----',name)
        console.log('type----',type)
      if(this.idWharhouse && this.idWharhouse._id){
        if (this.currentUser && this.currentUser.role && this.currentUser.role.name && this.currentUser.role.name != "Seller" && this.currentUser.type != "Seller"){
            await this.$store.dispatch('wharhouse/searchUser',{type: type ,warhouse:this.idWharhouse._id,search:name}).then((res) => {
              if(type == 'Seller') this.sellers = res
              else this.TabTeleConsultant = res
            })
        }else{
          if(type == 'Seller') this.sellers = [];
          else this.TabTeleConsultant = [];
        } 
      }
   }, 500),
   async refresh(){
      this.pagination={page:1,end:false}
      this.emtydataAnalaytice();this.TeleConsultantTab=[];
      if (this.formData.startDate && Array.isArray(this.formData.startDate) && this.formData.startDate.filter(function(el) { return el; }).length==2){
          await this.getTotalStatusPerTeleconsultantBetweenTwoDate();
      }else await this.getTotalOrdersPerTeleConsultant({IntervaleDate: this.duree});
   },
   convertdata(data){
          if(data && data.length>0 && data.filter(o => o.users.length==0).length == data.length) this.pagination.end=true;
          for (let i in data) {
             var index = this.dataAnalaytice.findIndex(x => x.type == data[i].type); 
             if(index === -1)  this.dataAnalaytice.push(data[i]) ;
             else{
                //this.dataAnalaytice[index].active=res.content.content[i].active;
                //this.dataAnalaytice[index].position=res.content.content[i].position;
                this.dataAnalaytice[index].users.push(...data[i].users);
                let resSame=[];
                this.dataAnalaytice[index].users.forEach(function (a) {
                    if (!this[a.user]) {
                        this[a.user] = { user: a.user, status: [], countAll:0, callAll:0, paid:0, confirmed:0, unrached:0};
                        resSame.push(this[a.user]);
                    }
                    this[a.user].countAll += a.countAll;
                    this[a.user].callAll += a.callAll;
                    this[a.user].paid += a.paid;
                    this[a.user].confirmed += a.confirmed;
                    this[a.user].unrached += a.unrached;
                    this[a.user].status.push(...a.status);
                    let resStatusSame=[];
                    this[a.user].status.forEach(function (b) {
                        if (!this[b.name]) {
                            this[b.name] = { name: b.name, count:0, percent:0, index:0};
                            resStatusSame.push(this[b.name]);
                        }
                        this[b.name].count += b.count;
                        this[b.name].index = b.index;
                    }, Object.create(null));
                    this[a.user].status=resStatusSame;
                }, Object.create(null));

                this.dataAnalaytice[index].users=resSame;
                this.dataAnalaytice[index].users.sort(function(a,b) {return b.countAll - a.countAll;});
              }   
          }

          console.log('convertdata.dataAnalaytice------',this.dataAnalaytice)
          
   },
    async getTotalOrdersPerTeleConsultant(filters) {
      this.loading=true;
      filters.warehouse=this.idWharhouse._id;
      filters.page=this.pagination.page;
      if (this.teleconsultantId) filters._id=this.teleconsultantId;
      if(this.sellerdata) filters.seller=this.sellerdata._id||this.sellerdata;
      if(this.productdata) filters.product=this.productdata._id||this.productdata;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
      filters['IntervaleDate']= this.duree;

      console.log('filter________________',filters)
      const res = await this.$server.getTotalOrdersPerTeleConsultant("analytics",filters);
       this.loading=false;
       console.log('res.content.content--------',res.content.content)
      if (res.content.content) {
          this.convertdata(res.content.content);
          await this.gateDatausersByType();
      }else {this.emtydataAnalaytice();this.TeleConsultantTab=[];this.pagination={page:1,end:false};this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
      this.emptyCount();
      await this.getTotal();
      console.log('dataAnalaytice--------',this.dataAnalaytice)
    },
    async getUserById(id){
        const editData = await this.$server.get("users", {id: id,ByActivity:true});
        return editData.content;
    },
     async next() {
      await this.getTotalOrdersPerTeleConsultant({IntervaleDate:  this.duree,page:++this.paginate.currentpage});
    },
    async prev() {
      await this.getTotalOrdersPerTeleConsultant({IntervaleDate:  this.duree,page:--this.paginate.currentpage});
    },
    async getTotalStatusPerTeleconsultant(filters) {
       this.loading=true;
       this.type="TeleConsultant";
       filters.warehouse=this.idWharhouse._id;
       const res = await this.$server.getTotalOrdersPerTeleConsultant("analytics",filters);
       this.loading=false;
      console.log('resssss',res)
       if (res.content.content) {
          this.convertdata(res.content.content);
          await this.gateDatausersByType();
      }else {this.emtydataAnalaytice();this.TeleConsultantTab=[];this.pagination={page:1,end:false};this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
      this.emptyCount();
      await this.getTotal();
    },
    async changeData() {
      this.duree = "";
      this.TabTeleConsultant = [];
    },
    async getTotalStatusPerTeleconsultantBetweenTwoDate(search=null) {
      this.type="TeleConsultant";
      let filters = {warehouse: this.idWharhouse._id,IntervaleDate: this.duree};
      if (this.teleconsultantId) filters._id=this.teleconsultantId;
      if(this.sellerdata) filters.seller=this.sellerdata._id||this.sellerdata;
      if(this.productdata) filters.product=this.productdata._id||this.productdata;
      if(search) {
        this.pagination={page:1,end:false};
        this.emtydataAnalaytice();this.TeleConsultantTab=[];
      }else filters.page=this.pagination.page;
      console.log('filters--------',filters)
      console.log('formData.startDate--------',this.formData)

      
      
      if (this.formData.startDate && Array.isArray(this.formData.startDate) && this.formData.startDate.filter(function(el) { return el; }).length==2){
          console.log('exist endDate--------')
          filters.startDate= this.formData.startDate.map( el => this.$moment(el).format('yyyy-MM-DD'));
          filters.endDate= this.formData.endDate;
          this.duree = "Two Date";
          if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters.warehouseParent=this.sous_idWharhouse;
          this.loading=true;
          const res = await this.$server.getTotalStatusPerTeleconsultantBetweenTwoDate("analytics",filters);
          this.loading=false;
          if(res.content) {
            console.log('res data-------',res)
             this.convertdata(res.content);
             await this.gateDatausersByType();
          }else {this.emtydataAnalaytice();this.TeleConsultantTab=[];this.pagination={page:1,end:false};this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
          this.emptyCount();
          await this.getTotal();
      }else{
        if(this.duree == "Two Date")  this.duree='Today';
        console.log('no betwen twpo datefilters--------',filters)
         await this.getTotalOrdersPerTeleConsultant(filters);
      }
    },

    async getOrdersX() {
      this.duree = "Two Date";
      this.TeleConsultantTab = [];
    },
  },
  watch: {
    'warhouseSelected': async function(oldVal, newVal) {
            // await this.getwharhouseId();
            // await this.getUsers();
            // this.pagination={page:1,end:false};
            // await this.getTotalOrdersPerTeleConsultant({IntervaleDate:  this.duree});
            // this.emptyCount();
            // await this.getTotal();
            // await this.getSellers();
    },
    'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          await this.getUsers();
          this.pagination={page:1,end:false};
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate:  this.duree});
          this.emptyCount();
          await this.getTotal();
          await this.getSellers();
    },
    'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          this.pagination={page:1,end:false};
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate:  this.duree});
          this.emptyCount();
          await this.getTotal();
    },
    teleconsultantId: async function (newVal, oldVal) {
      this.teleconsultantId=this.teleconsultantId;
      this.pagination={page:1,end:false};
      await this.getTotalStatusPerTeleconsultantBetweenTwoDate();
    },
    startDate: async function (newVal, oldVal) {
      console.log("HIII newVal", newVal);
      console.log("HIII old val", oldVal);
    },
    duree: async function (newVal, oldVal) {
      switch (this.duree) {
        case "Today":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Today",});
          break;
        case "Yesterday":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false};
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Yesterday",});
          break;
        case "This Month":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "This Month",});
          break;
        case "Last Month":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Last Month",});
          break;

        case "This Year":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "This Year",});
           console.log('telecosultant',this.TeleConsultantTab)
          break;

        case "Last Year":
          this.TeleConsultantTab = [];
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Last Year",});
          break;

        case "Two Date":
          this.TeleConsultantTab = [];
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalStatusPerTeleconsultantBetweenTwoDate();
          break;

        default:
          this.TeleConsultantTab = [];
          this.duree = "Today";
          this.formData.startDate = "";
          this.formData.endDate = "";
          this.pagination={page:1,end:false}
          this.emtydataAnalaytice();this.TeleConsultantTab=[];
          await this.getTotalOrdersPerTeleConsultant({IntervaleDate: "Today",});
      }
    },
  },
};
</script>
<style scoped>
.line.l {
    left: 0;
}
.line {
  border-top: 2px solid #3282d0;
    position: absolute;
    top: 27px;
    width: 41%;
}
.line.r {
    right: 0;
}
.loadMore {
  text-align: center;
  width: 100%;
  float: none;
  margin: 18px auto 18px;
  overflow: hidden;
  position: relative;
}
.loadMore button{
    box-shadow: inset 0 0 20px rgb(255 255 255 / 0%);
    outline: 1px solid;
    outline-color: rgba(255, 255, 255, 0.5);
    outline-offset: 0px;
    text-shadow: none;
    transition: all 1250ms cubic-bezier(0.19, 1, 0.22, 1);
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    line-height: 45px;
    max-width: 160px;
    position: relative;
    text-decoration: none;
    background-color: #3182cf;
    width: 100%;
}
  .delevry-moto{
    box-shadow: none !important;
    display: inline-block;
    width: 17px
  }
.bg-info-line {
    background-color: #15a814;
}
.bg-cancelled-line{
  background-color: #e30b0b;
}
.text-info-line {
    color: #15a814;
}
.text-cancelled-line{
  color: #e30b0b;
}

.bg-trait-line{
  background-color: #4b5668;
}
.bg-paid-line{
  background-color: #966a0e;
}
.bullet-vertical {
    width: 4px;
    height: 8px;
    border-radius: 6px;
    flex-shrink: 0;
    min-height: 25px;
    margin-right: 10px;
    max-height: 100%;
}
  .flex-stack {
    justify-content: space-between;
    align-items: center;
}
.fw-semibold {
    font-weight: 500;
}
.separator.separator-dashed {
    border-bottom-style: dashed;
    border-bottom-color: #04bbc9;
}
.separator-paid{
    border-bottom-color: #876cff !important;
}
.separator {
    display: block;
    height: 0;
    border-bottom: 1px solid #eff2f5;
}
.my-3 {
    margin-top: 0.75rem ;
    margin-bottom: 0.75rem ;
}
.fs-6 {
    font-size: 1.075rem ;
}
.me-2 {
    margin-right: 0.5rem !important;
}
.fw-bolder {
    font-weight: 700 !important;
}
.fs-6 {
    font-size: 1.075rem !important;
}
  .nav  {
    padding-left: 0.25rem;
  }
  .loader12 {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    animation: loader12 1s linear alternate infinite;
    top: 50%;
    margin: -46px auto 0 70px;
}
@keyframes loader12 {
  0% {
    box-shadow: -60px 40px 0 2px #0052ec, -30px 40px 0 0 rgba(0, 82, 236, 0.2), 0 40px 0 0 rgba(0, 82, 236, 0.2), 30px 40px 0 0 rgba(0, 82, 236, 0.2), 60px 40px 0 0 rgba(0, 82, 236, 0.2); }
  25% {
    box-shadow: -60px 40px 0 0 rgba(0, 82, 236, 0.2), -30px 40px 0 2px #0052ec, 0 40px 0 0 rgba(0, 82, 236, 0.2), 30px 40px 0 0 rgba(0, 82, 236, 0.2), 60px 40px 0 0 rgba(0, 82, 236, 0.2); }
  50% {
    box-shadow: -60px 40px 0 0 rgba(0, 82, 236, 0.2), -30px 40px 0 0 rgba(0, 82, 236, 0.2), 0 40px 0 2px #0052ec, 30px 40px 0 0 rgba(0, 82, 236, 0.2), 60px 40px 0 0 rgba(0, 82, 236, 0.2); }
  75% {
    box-shadow: -60px 40px 0 0 rgba(0, 82, 236, 0.2), -30px 40px 0 0 rgba(0, 82, 236, 0.2), 0 40px 0 0 rgba(0, 82, 236, 0.2), 30px 40px 0 2px #0052ec, 60px 40px 0 0 rgba(0, 82, 236, 0.2); }
  100% {
    box-shadow: -60px 40px 0 0 rgba(0, 82, 236, 0.2), -30px 40px 0 0 rgba(0, 82, 236, 0.2), 0 40px 0 0 rgba(0, 82, 236, 0.2), 30px 40px 0 0 rgba(0, 82, 236, 0.2), 60px 40px 0 2px #0052ec; }
   }

  .card-block.card-height {
    height: calc(100% - 30px);
}
.card-block.card-stretch {
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
}
.card {
    border: none;
    position: relative;
    background: #fff;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border-radius: 8px;
    margin-bottom: 30px;
    -webkit-box-shadow: 0px 16px 40px 0px #0000000a;
    -moz-box-shadow: 0px 16px 40px 0px #0000000A;
    -ms-box-shadow: 0px 16px 40px 0px #0000000A;
    -o-box-shadow: 0px 16px 40px 0px #0000000A;
    box-shadow: 0px 16px 40px 0px #0000000a;
    min-width: 0;
    word-wrap: break-word;
}
.card-block {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    box-shadow: 0 13px 40px rgb(198 197 202);
    border-bottom: 4px solid;
}
.text-primary {
    color: #05bbc9 !important;
}
.text-info {
    color: #876cfe !important;
}
.card-block img {
  padding: 8px;
}
.card-block h2 {
    font-weight: 500;
    margin: 0px;
    line-height: 1.5;
    color: #303030;
    font-size: 2.3em;
}
.card-block  h5 {
    font-weight: 500;
    margin: 0px;
    line-height: 1.5;
    color: #303030;
    font-size: 1.1em;
}
.bg-info-light {
    color: #2900da !important;
    background-color: #e1daff !important;
}
.rounded {
    border-radius: 8px !important;
}
.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
    padding-bottom: 10px;
    padding-top: 10px;
}
.align-items-center {
    align-items: center !important;
}
.justify-content-between {
    justify-content: space-between !important;
}
.d-flex {
    display: flex !important;
}
.bg-info {
    color: #fff !important;
    background-color: #876cfe !important;
}
.iq-card-icon {
    height: 60px;
    width: 60px;
    display: inline-block;
    line-height: 60px;
    text-align: center;
    font-size: 22px;
}
.rounded {
    border-radius: 8px !important;
}
.bg-primary-light {
    color: #27a6b1 !important;
    background-color: #dff6f8 !important;
}
.bg-primary {
    color: #fff !important;
    background-color: #05bbc9 !important;
}
.box {
    border-color: transparent;
    border-radius: .375rem;
    position: relative;
}
.text-xs {
  font-size: .60rem;
}
.input-style{
    padding: 0.375rem 0.75rem;
    font-size: 0.9375rem;
    line-height: 1.6;
    color: #9493a9 !important;
    background-color: #f4f3f9;
    background-clip: padding-box;
    border: 1px solid #e1e0ea;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-radius: 3px;
  }
.mt-0\.5 {
  margin-top: .125rem;
}
.fz-12{
  font-size: 12px;
  vertical-align: top;
}
.filter-tel{
  border: 1px solid #dcdee0;
  padding: 20px;
  box-shadow: 0 13px 40px rgb(198 197 202);
}
.bg-redd{
     background-color: #f3bcbc !important;
}
div.online-indicator {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 10px;
    background-color: #0fcc45;
    border-radius: 50%;
    position: relative;
}
span.blink {
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    animation: blink 1s linear infinite;
}

h2.online-text {
    display: inline;
    font-family: 'Rubik', sans-serif;
    font-weight: 400;
    text-shadow: 0px 3px 6px rgb(150 150 150 / 20%);
    position: relative;
    cursor: pointer;
    vertical-align: top;
    font-size: 14px;
}
span.blink .online{
   background-color: #0fcc45;
   opacity: 0.7;
}
span.blink.offline{
    background-color: #e10b0b;
    opacity: 1;
}
.btn{
   background-color: none;
   color: none;
}
.btn-an {
    border-radius: .375rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-duration: .15s;
    transition-duration: .2s;
}
.dark .nav.nav-tabs.boxed-tabs a.active, .nav.nav-tabs.boxed-tabs a.active {
    --tw-text-opacity: 1;
    color: rgba(255,255,255,var(--tw-text-opacity));
}
.dark .nav.nav-tabs.boxed-tabs a.active, .nav.nav-tabs.boxed-tabs a.active {
    --tw-bg-opacity: 1;
    background-color: rgba(28,63,170,var(--tw-bg-opacity));
}
.nav.nav-tabs.boxed-tabs a {
    border-bottom-width: 0;
}
.nav.nav-tabs .active {
    --tw-border-opacity: 1;
    border-color: rgba(28,63,170,var(--tw-border-opacity));
    border-bottom-width: 2px;
    font-weight: 500;
}
.td-f{
  background-color: #abe2ff !important;
}
.box {
  box-shadow: 0 3px 20px rgb(0 0 0 / 35%);
  background-color: rgba(255,255,255);

}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.padding-empty{
   padding-top: 3rem !important;
   padding-bottom: 3rem !important;
}

.tele .table td, .tele .table th {
    padding-top: .20rem;
    padding-bottom: .20rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    line-height: 20px;
}
.tele .table th {
    font-weight: 500;
    font-size: 12px;
}
.whitespace-nowrap {
    white-space: nowrap;
}
*>.intro-x:first-child {
 transform:translateX(50px)
}
*>.-intro-x:first-child,
*>.intro-x:first-child {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.-intro-x:first-child {
 transform:translateX(-50px)
}
*>.intro-y:first-child {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.1s;
 animation-delay:.1s
}
*>.intro-x:nth-child(2) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(2),
*>.intro-x:nth-child(2) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.-intro-x:nth-child(2) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(2) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.2s;
 animation-delay:.2s
}
*>.intro-x:nth-child(3) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(3),
*>.intro-x:nth-child(3) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.-intro-x:nth-child(3) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(3) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.3s;
 animation-delay:.3s
}
*>.intro-x:nth-child(4) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(4),
*>.intro-x:nth-child(4) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.-intro-x:nth-child(4) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(4) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.4s;
 animation-delay:.4s
}
*>.intro-x:nth-child(5) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(5),
*>.intro-x:nth-child(5) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.-intro-x:nth-child(5) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(5) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.5s;
 animation-delay:.5s
}
*>.intro-x:nth-child(6) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(6),
*>.intro-x:nth-child(6) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.-intro-x:nth-child(6) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(6) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.6s;
 animation-delay:.6s
}
*>.intro-x:nth-child(7) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(7),
*>.intro-x:nth-child(7) {
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.-intro-x:nth-child(7) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(7) {
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.7s;
 animation-delay:.7s
}
*>.intro-x:nth-child(8) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(8),
*>.intro-x:nth-child(8) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.-intro-x:nth-child(8) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(8) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.8s;
 animation-delay:.8s
}
*>.intro-x:nth-child(9) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(9),
*>.intro-x:nth-child(9) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.-intro-x:nth-child(9) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(9) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:.9s;
 animation-delay:.9s
}
*>.intro-x:nth-child(10) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(10),
*>.intro-x:nth-child(10) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.-intro-x:nth-child(10) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(10) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1s;
 animation-delay:1s
}
*>.intro-x:nth-child(11) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(11),
*>.intro-x:nth-child(11) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.-intro-x:nth-child(11) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(11) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.1s;
 animation-delay:1.1s
}
*>.intro-x:nth-child(12) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(12),
*>.intro-x:nth-child(12) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.-intro-x:nth-child(12) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(12) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.2s;
 animation-delay:1.2s
}
*>.intro-x:nth-child(13) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(13),
*>.intro-x:nth-child(13) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.-intro-x:nth-child(13) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(13) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.3s;
 animation-delay:1.3s
}
*>.intro-x:nth-child(14) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(14),
*>.intro-x:nth-child(14) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.-intro-x:nth-child(14) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(14) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.4s;
 animation-delay:1.4s
}
*>.intro-x:nth-child(15) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(15),
*>.intro-x:nth-child(15) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.-intro-x:nth-child(15) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(15) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.5s;
 animation-delay:1.5s
}
*>.intro-x:nth-child(16) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(16),
*>.intro-x:nth-child(16) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.-intro-x:nth-child(16) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(16) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.6s;
 animation-delay:1.6s
}
*>.intro-x:nth-child(17) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(17),
*>.intro-x:nth-child(17) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.-intro-x:nth-child(17) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(17) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.7s;
 animation-delay:1.7s
}
*>.intro-x:nth-child(18) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(18),
*>.intro-x:nth-child(18) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.-intro-x:nth-child(18) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(18) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.8s;
 animation-delay:1.8s
}
*>.intro-x:nth-child(19) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(19),
*>.intro-x:nth-child(19) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.-intro-x:nth-child(19) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(19) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:1.9s;
 animation-delay:1.9s
}
*>.intro-x:nth-child(20) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(20),
*>.intro-x:nth-child(20) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.-intro-x:nth-child(20) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(20) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2s;
 animation-delay:2s
}
*>.intro-x:nth-child(21) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(21),
*>.intro-x:nth-child(21) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.-intro-x:nth-child(21) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(21) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.1s;
 animation-delay:2.1s
}
*>.intro-x:nth-child(22) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(22),
*>.intro-x:nth-child(22) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.-intro-x:nth-child(22) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(22) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.2s;
 animation-delay:2.2s
}
*>.intro-x:nth-child(23) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(23),
*>.intro-x:nth-child(23) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.-intro-x:nth-child(23) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(23) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.3s;
 animation-delay:2.3s
}
*>.intro-x:nth-child(24) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(24),
*>.intro-x:nth-child(24) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.-intro-x:nth-child(24) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(24) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.4s;
 animation-delay:2.4s
}
*>.intro-x:nth-child(25) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(25),
*>.intro-x:nth-child(25) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.-intro-x:nth-child(25) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(25) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.5s;
 animation-delay:2.5s
}
*>.intro-x:nth-child(26) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(26),
*>.intro-x:nth-child(26) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.-intro-x:nth-child(26) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(26) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.6s;
 animation-delay:2.6s
}
*>.intro-x:nth-child(27) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(27),
*>.intro-x:nth-child(27) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.-intro-x:nth-child(27) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(27) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.7s;
 animation-delay:2.7s
}
*>.intro-x:nth-child(28) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(28),
*>.intro-x:nth-child(28) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.-intro-x:nth-child(28) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(28) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.8s;
 animation-delay:2.8s
}
*>.intro-x:nth-child(29) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(29),
*>.intro-x:nth-child(29) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.-intro-x:nth-child(29) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(29) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:2.9s;
 animation-delay:2.9s
}
*>.intro-x:nth-child(30) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(30),
*>.intro-x:nth-child(30) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.-intro-x:nth-child(30) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(30) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3s;
 animation-delay:3s
}
*>.intro-x:nth-child(31) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(31),
*>.intro-x:nth-child(31) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.-intro-x:nth-child(31) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(31) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.1s;
 animation-delay:3.1s
}
*>.intro-x:nth-child(32) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(32),
*>.intro-x:nth-child(32) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.-intro-x:nth-child(32) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(32) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.2s;
 animation-delay:3.2s
}
*>.intro-x:nth-child(33) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(33),
*>.intro-x:nth-child(33) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.-intro-x:nth-child(33) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(33) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.3s;
 animation-delay:3.3s
}
*>.intro-x:nth-child(34) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(34),
*>.intro-x:nth-child(34) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.-intro-x:nth-child(34) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(34) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.4s;
 animation-delay:3.4s
}
*>.intro-x:nth-child(35) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(35),
*>.intro-x:nth-child(35) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.-intro-x:nth-child(35) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(35) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.5s;
 animation-delay:3.5s
}
*>.intro-x:nth-child(36) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(36),
*>.intro-x:nth-child(36) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.-intro-x:nth-child(36) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(36) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.6s;
 animation-delay:3.6s
}
*>.intro-x:nth-child(37) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(37),
*>.intro-x:nth-child(37) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.-intro-x:nth-child(37) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(37) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.7s;
 animation-delay:3.7s
}
*>.intro-x:nth-child(38) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(38),
*>.intro-x:nth-child(38) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.-intro-x:nth-child(38) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(38) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.8s;
 animation-delay:3.8s
}
*>.intro-x:nth-child(39) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(39),
*>.intro-x:nth-child(39) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.-intro-x:nth-child(39) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(39) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:3.9s;
 animation-delay:3.9s
}
*>.intro-x:nth-child(40) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(40),
*>.intro-x:nth-child(40) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.-intro-x:nth-child(40) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(40) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4s;
 animation-delay:4s
}
*>.intro-x:nth-child(41) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(41),
*>.intro-x:nth-child(41) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.-intro-x:nth-child(41) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(41) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.1s;
 animation-delay:4.1s
}
*>.intro-x:nth-child(42) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(42),
*>.intro-x:nth-child(42) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.-intro-x:nth-child(42) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(42) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.2s;
 animation-delay:4.2s
}
*>.intro-x:nth-child(43) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(43),
*>.intro-x:nth-child(43) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.-intro-x:nth-child(43) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(43) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.3s;
 animation-delay:4.3s
}
*>.intro-x:nth-child(44) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(44),
*>.intro-x:nth-child(44) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.-intro-x:nth-child(44) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(44) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.4s;
 animation-delay:4.4s
}
*>.intro-x:nth-child(45) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(45),
*>.intro-x:nth-child(45) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.-intro-x:nth-child(45) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(45) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.5s;
 animation-delay:4.5s
}
*>.intro-x:nth-child(46) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(46),
*>.intro-x:nth-child(46) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.-intro-x:nth-child(46) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(46) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.6s;
 animation-delay:4.6s
}
*>.intro-x:nth-child(47) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(47),
*>.intro-x:nth-child(47) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.-intro-x:nth-child(47) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(47) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.7s;
 animation-delay:4.7s
}
*>.intro-x:nth-child(48) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(48),
*>.intro-x:nth-child(48) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.-intro-x:nth-child(48) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(48) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.8s;
 animation-delay:4.8s
}
*>.intro-x:nth-child(49) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(49),
*>.intro-x:nth-child(49) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.-intro-x:nth-child(49) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(49) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:4.9s;
 animation-delay:4.9s
}
*>.intro-x:nth-child(50) {
 transform:translateX(50px)
}
*>.-intro-x:nth-child(50),
*>.intro-x:nth-child(50) {
 
 opacity:0;
 position:relative;
 -webkit-animation:intro-x-animation .4s ease-in-out .33333s;
 animation:intro-x-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
*>.-intro-x:nth-child(50) {
 transform:translateX(-50px)
}
*>.intro-y:nth-child(50) {
 
 opacity:0;
 position:relative;
 transform:translateY(50px);
 -webkit-animation:intro-y-animation .4s ease-in-out .33333s;
 animation:intro-y-animation .4s ease-in-out .33333s;
 -webkit-animation-fill-mode:forwards;
 animation-fill-mode:forwards;
 -webkit-animation-delay:5s;
 animation-delay:5s
}
@-webkit-keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@keyframes intro-x-animation {
 to {
  opacity:1;
  transform:translateX(0)
 }
}
@-webkit-keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
@keyframes intro-y-animation {
 to {
  opacity:1;
  transform:translateY(0)
 }
}
.table-report img {
    box-shadow: 0 0 0 2px #fff,1px 1px 5px rgba(0,0,0,.32);
}
.image-fit {
    position: relative;
    display: flex;
  justify-content: center;
  align-items: center;
}
.table-report:not(.table-report--bordered):not(.table-report--tabulator) {
    border-spacing: 0 10px;
    border-collapse: separate;
}
.table-report:not(.table-report--bordered):not(.table-report--tabulator) td:first-child {
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
}
.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {
    box-shadow: 20px 3px 20px rgba(0,0,0,.043137254901960784);
}
.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {
    background-color: rgba(255,255,255);
}
.image-fit > img {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    position: absolute;
    width: 100%;
}

.progress-circle::after {
    background-color: #0083ff;
    border-radius: 50%;
    content: '';
    display: inline-block;
    height: 100%;
    width: 100%;
}
.progress-circle::before {
    align-items: center;
    background-color: #fff;
    border-radius: 50%;
    content: attr(data-progress) '%';
    display: flex;
    font-size: 1rem;
    justify-content: center;
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 1rem;
    bottom: 1rem;
    transition: transform 0.2s ease;
}
.progress-circle {
   background-color: #ddd;
    border-radius: 50%;
    display: inline-block;
    height: 5rem;
    margin: 1rem 1rem 0;
    position: relative;
    width: 5rem
}
.btn-circle {
    border-radius: 100%;
    width: 40px;
    height: 40px;
    padding: 5px;
    line-height: 30px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    font-size: .875rem;
}
</style>
